import {Component, OnInit} from '@angular/core';
import {Promotion} from '../../models/promotions/promotion.model';
import {HttpService} from '../../services/http.service';
import {Filter} from '../../models/warranties/filter.model';

@Component({
  selector: 'app-promotions',
  templateUrl: './promotions.component.html',
  styleUrls: ['./promotions.component.css']
})
export class PromotionsComponent implements OnInit {

  promotions: Promotion[] = [];
  filter: Filter = new Filter();

  constructor(private http: HttpService) {
  }

  ngOnInit(): void {
    this.http.fetchPromotions().subscribe((res: Promotion[]) => {
      this.promotions = Object.assign([], res);
    });
  }

  orderBy(field: string) {

  }

  showDirectionImage(): string {
    if (this.filter.order === 'ASC') {
      return 'assets/images/icon-sort-up.png';
    } else {
      return 'assets/images/icon-sort-down.png';
    }
  }

  downloadPromotionFile(id: number, d: string) {
    return this.http.downloadFile(id, d);
  }

}
